import React from 'react';
import {Routes, Route} from 'react-router-dom';
import Pokemons from "./pages/Pokemons";
import Pokemon from "./pages/Pokemon";
import Iteam from "./pages/Iteam"
import Abiliti from "./pages/Abiliti"
import History from "./pages/History";
import WinRatecalculator from "./pages/WinRatecalculator";
import Team1 from "./pages/Team1";
import Team2 from "./pages/Team2";
import TeamWinCal from "./pages/TeamWinCal";
import TeamCreate from "./pages/TeamCreate";

const App = () => {

    return (
        <Routes>
            <Route path="/pokemons" element={<Pokemons/>}/>
            <Route path="/pokemons/:name" element={<Pokemon/>}/>
            <Route path="/pokemons/History" element={<History/>}/>
            <Route path="/pokemons/Calc" element={<WinRatecalculator/>}/>
            <Route path="/pokemons/Iteam/:id" element={<Iteam/>}/>
            <Route path="/pokemons/Abiliti/:url" element={<Abiliti/>}/>
            <Route path={"/pokemons/team1"} element={<Team1/>}/>
            <Route path={"/pokemons/team2"} element={<Team2/>}/>
            <Route path={"/pokemons/TeamWinCal"} element={<TeamWinCal/>}/>
            <Route path={"/pokemons/TeamCreator"} element={<TeamCreate/>}/>
        </Routes>
    )
}

export default App;
